import React, { useState, useEffect } from "react";
import config from "../../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import { exportToExcel } from "react-json-to-excel";
const ExcelTaxList1 = (props) => {
  const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID, setUserID] = useState(localStorage.getItem("ID"));
  const [MemberType, setMemberType] = useState(
    localStorage.getItem("MemberType")
  );
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [listOfLedger, setLedger] = useState([]);
  const [selectedYear, setselectedYear] = useState("");
  const [selectedMonth, setselectedMonth] = useState("");
  const [selectedAmount, setAmount] = useState(0);

  useEffect(() => {
    document.title = "Employee Tax List 1";

    setLoading(true);
    // Get the URL parameters
    setselectedYear(props.year);
    setselectedMonth(props.Month);
    setAmount(props.Amount);

    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      Fyear: props.year,
      SelectedMonth: props.month,
      EmployeeTypeId: props.EmployeeTypeId,
      PayScale: props.PayScale,
      Amount: props.Amount,
    };

    // console.log(data);
    var api_config = {
      method: "post",
      url: config.base_url + "Payroll/GetTaxList1",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    //console.log(data);

    axios(api_config)
      .then(function (response) {
        console.log(response.data);
        let data = response.data.ListofRecords;
        const listOfEmployeeData = data.map(({ ...item }, index) => ({
          SrNo: index + 1,
          Code: item.SelectedEmployee?.Code,
          Staff_Name: item.SelectedEmployee?.Name,
          Father_Name: item.SelectedEmployee?.Father_Name,
          Designation: item.SelectedEmployee?.SelectedDesignation?.Name,
          Qualification: item.SelectedEmployee?.Qualification,
          BPS: item.SelectedEmployee?.GPS_Scale, // BPS corresponds to GPS_Scale
          CNIC_No: item.SelectedEmployee?.CNIC_NO,
          Gross: item.Gross,
          Tax_Paid: "", // No tax data available
          Mobile_No: item.SelectedEmployee?.Mobile_No,
          Remarks: "", // No remarks data available
        }));

        setLedger(listOfEmployeeData);

        setLoading(false);
      })
      .catch(function (error) {
        //console.log(error);
      });
  }, []);



  return (
    <>
      <button disabled={loading} className="button button-primary-outline excel-button" onClick={() => exportToExcel(listOfLedger, 'Manage Enquiry List')}>
        {loading ? <Spinner /> : <i className="ri-file-excel-2-line"></i>}
      </button>
    </>
  );
};

export default ExcelTaxList1;
